export default __webpack_public_path__ + "static/california-state-outline-21e9ad69ee49492e6520e02f24d8db23.png";